import React from 'react';
import { LottieLoader } from '../../../form/ui/lottie.loader';
import { Typography } from '@sravni/react-design-system';
import animationData from './animations/banks.json';
import styles from './styles.module.scss';

export const BanksLoad: React.FC = () => {
    return (
        <div className={styles.wrapper}>
            <LottieLoader className={styles.imageContainer} options={{ animationData }} height={170} />
            <Typography.Heading className={styles.heading} level={4}>
                Ищем банки с высокой вероятностью одобрения
            </Typography.Heading>
        </div>
    );
};
